var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM10.2071 8.79289C9.81658 8.40237 9.18342 8.40237 8.79289 8.79289C8.40237 9.18342 8.40237 9.81658 8.79289 10.2071L10.5858 12L8.79289 13.7929C8.40237 14.1834 8.40237 14.8166 8.79289 15.2071C9.18342 15.5976 9.81658 15.5976 10.2071 15.2071L12 13.4142L13.7929 15.2071C14.1834 15.5976 14.8166 15.5976 15.2071 15.2071C15.5976 14.8166 15.5976 14.1834 15.2071 13.7929L13.4142 12L15.2071 10.2071C15.5976 9.81658 15.5976 9.18342 15.2071 8.79289C14.8166 8.40237 14.1834 8.40237 13.7929 8.79289L12 10.5858L10.2071 8.79289Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClear);
export default __webpack_public_path__ + "static/media/ic_clear.e0540c9371c69e594fd2198da7da6237.svg";
export { ForwardRef as ReactComponent };